import startCase from "lodash/startCase";

const getTranslationKeyExists = (i18n: any, localeKey: string) => {
  return i18n.te(localeKey, "en");
};

/**
 * @param {i18n} i18n from useI18n
 * @param {string} localeKey key to the translation
 * @param {string} fallback fallback string in case translation doesn't exist
 * @description If the translation key exists, will try to translate and possibly fallback to English. If the key doesn't exist, will return the fallback value if it exists, otherwise will return the startCased last part of the localeKey.
 */
export default (
  i18n: any,
  localeKey: string,
  fallback?: string,
  params?: any,
): string => {
  if (getTranslationKeyExists(i18n, localeKey)) {
    return i18n.t(localeKey, params); // will fallback to English, if the key doesn't exist in the current locale
  }

  const localeKeyLastPart = localeKey.split(".").pop(); // "product.description.heading" --> "heading"

  return fallback || startCase(localeKeyLastPart);
};
